import './extraMenuItems.css';

export default function ExtraMenuItems() {
    return (
        <div>
            <svg width="31.318" height="30.014" viewBox="0 0 31.318 30.014">
                <path id="Icon_material-sharp-hub" data-name="Icon material-sharp-hub" d="M10.961,23.75a3.852,3.852,0,0,1,.783,2.349,3.9,3.9,0,1,1-2.31-3.576l1.84-2.31A5.877,5.877,0,0,1,9.852,15.4L7.2,14.511A3.907,3.907,0,1,1,7.83,12.4a1.927,1.927,0,0,1-.013.274l2.649.887a5.83,5.83,0,0,1,4.2-3.027V7.712a3.921,3.921,0,1,1,1.97,0v2.819a5.831,5.831,0,0,1,4.2,3.027l2.649-.887V12.4a3.911,3.911,0,1,1,.626,2.127l-2.649.887a5.859,5.859,0,0,1-1.422,4.815l1.84,2.31a3.7,3.7,0,0,1,1.605-.352A3.915,3.915,0,1,1,19.574,26.1a3.852,3.852,0,0,1,.783-2.349l-1.84-2.31a5.871,5.871,0,0,1-5.7,0Z" fill="#72bf72"/>
            </svg>
        </div>
    )
}